import { buildImpersonationUser } from '@shared/utils/impersonation';
import { tokenService } from '../../../services/tokenService';
import { resetUserScopedApiState } from '../../../store/api/resetUserScopedApiState';
import { setSession, startImpersonation } from '../../../store/auth/authSlice';
import type { AppDispatch } from '../../../store/store';

interface AdminUser {
  id: string;
  email: string;
  organizationId: string;
  roles: string[];
  permissions: string[];
  permissionsHash?: string;
  firstName?: string;
  lastName?: string;
  avatarUrl?: string;
}

interface ImpersonationTarget {
  id: string;
  name: string;
  email: string;
  org_id: string;
  given_name: string;
  family_name: string;
  roles: string[];
  permissions: string[];
}

interface ImpersonationResult {
  access_token: string;
  expires_at: string;
  target: ImpersonationTarget;
}

interface StartAdminImpersonationSessionParams {
  dispatch: AppDispatch;
  navigate: (path: string) => void;
  currentToken: string;
  currentUser: AdminUser;
  result: ImpersonationResult;
  returnPath?: string;
}

export function startAdminImpersonationSession({
  dispatch,
  navigate,
  currentToken,
  currentUser,
  result,
  returnPath,
}: StartAdminImpersonationSessionParams) {
  const impersonationState = {
    targetId: result.target.id,
    targetName: result.target.name,
    targetEmail: result.target.email,
    targetOrgId: result.target.org_id,
    targetRoles: result.target.roles,
    targetPermissions: result.target.permissions,
    returnPath,
    token: result.access_token,
    expiresAt: result.expires_at,
    originalToken: currentToken,
    originalUser: currentUser,
  };

  tokenService.saveImpersonationState(impersonationState);
  dispatch(startImpersonation(impersonationState));
  dispatch(
    setSession({
      token: result.access_token,
      user: buildImpersonationUser({
        id: result.target.id,
        email: result.target.email,
        name: result.target.name,
        orgId: result.target.org_id,
        givenName: result.target.given_name,
        familyName: result.target.family_name,
        roles: result.target.roles,
        permissions: result.target.permissions,
      }),
    })
  );
  resetUserScopedApiState(dispatch);
  navigate('/');
}
